module.exports = __webpack_public_path__ + "static/img/interpretive-graphic-panels.6bd3c3c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pages/products/interpretive-graphic-panels.jpg
// module id = 423
// module chunks = 0